.container {
  .trigger {
    border: 1px solid var(--color-grayscale-trout);

    &:hover {
      border-color: var(--text-color-white);
    }
  }
}
